'use client' // Error boundaries must be Client Components
import React, {useEffect} from 'react'

import * as Sentry from '@sentry/nextjs'

import '@ant-design/v5-patch-for-react-19'

import Error from '@/src/shared/ui/error'

import Providers from '@/src/providers'
import '@/src/shared/assets/styles/global.css'


const Html = ({children}: React.PropsWithChildren) => (
  <html lang="ru">
    <body id="body">
      {children}
    </body>
  </html>
)

export default function GlobalError({error}: {error: Error & {digest?: string}}) {
  useEffect(() => {
    console.error(error)
    Sentry.captureException(error)
  }, [])

  return (
    <Html>
      <title>Ошибка</title>
      <Providers>
        <Error status={500} global={true}>
          {(process.env.NODE_ENV === 'development' && <div dangerouslySetInnerHTML={{__html: error.message}}></div>) ||
            'Извините, на нашем сайте временно возникли технические неполадки. Мы уже работаем над их устранением! Пожалуйста, попробуйте обновить страницу или вернуться чуть позже. Спасибо за ваше терпение и понимание.'}
        </Error>
      </Providers>
    </Html>
  )
}
